// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotPassword {
  padding: 3em 0;
}

.forgotPassword__container {
  display: flex;
  flex-direction: column;
  padding: 3em 0;
  margin-top: 2rem;
  gap: 1rem;
  max-width: 45rem;
  width: 100%;
}

.forgotPassword__title {
  font-size: 2rem;
  margin-bottom: 0.25rem;
}

.forgotPassword__title ~ span {
  line-height: 1.8;
}

.forgotPassword__connect {
  margin-top: 2rem;
}

.forgotPassword__connect h4 {
  font-weight: bold;
}

.forgotPassword__connectOptions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}

.forgotPassword__connectBtn {
  border: 0.15rem solid var(--clr-primary);
  color: var(--clr-primary);
  flex: 1 1 33%;
  background: transparent;
  justify-content: center;
  border-radius: 0.75em;
  font-weight: bold;
  font-size: 0.9rem;
  white-space: nowrap;
  max-width: unset;
  padding: 1em 1.25em;
}

.forgotPassword__connectBtn img,
.forgotPassword__connectBtn svg {
  width: 1.25rem;
  margin-left: 0.5rem;
}

.forgotPassword__connectBtn img {
  margin-right: 0.5rem;
}

.forgotPassword__connectBtn.google {
  border: 0.15rem solid var(--clr-black);
  color: var(--clr-black);
}
.forgotPassword__connectBtn.facebook {
  border: 0.15rem solid var(--clr-blue);
  color: var(--clr-blue);
}

.forgotPassword__or {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  font-weight: bolder;
  margin: 2rem auto;
  color: var(--clr-gray500);
  font-size: 0.9rem;
  z-index: 1;
}

.forgotPassword__or::before,
.forgotPassword__or::after {
  content: "";
  position: absolute;
  height: 0.05rem;
  width: 45%;
  top: 50%;
  transform: translateY(-50%);
  background: var(--clr-gray500);
}
.forgotPassword__or::before {
  left: 0;
}
.forgotPassword__or::after {
  right: 0;
}

.forgotPassword__btn {
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  justify-content: center;
  padding-block: 0.75em;
  border-radius: 0.75em;
  margin-top: 1.5rem;
}

.forgotPassword__btn svg {
  width: 1.75rem;
  margin-left: 0.5rem;
}

.forgotPassword__note {
  display: flex;
  align-items: center;
  line-height: 1.5;
  text-align: center;
  margin-top: 1rem;
  font-size: 0.8rem;
  justify-content: center;
}

.forgotPassword__note svg {
  width: 1.25rem;
  margin-right: 0.5rem;
}

/* input */

.forgotPassword__input {
  display: grid;
  gap: 1rem;
  /* margin-bottom: 3rem; */
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
}

.forgotPassword__input.login {
  display: flex;
  flex-direction: column;
}

.forgotPassword__inputContainer {
  display: flex;
  flex-direction: column;
  flex: 1 1 20%;
  width: 100%;
  position: relative;
}

.forgotPassword__inputContainer.error input {
  border: 2px solid var(--clr-error-dark);
}

.forgotPassword__inputContainer label {
  position: absolute;
  left: 1rem;
  top: 0rem;
  color: var(--clr-gray400);
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  margin: 0.5rem 0;
  cursor: text;
}

.forgotPassword__inputContainer input::placeholder {
  letter-spacing: 0.05rem;
}

.forgotPassword__inputContainer input {
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: 400;
  padding: 1em 1.25em;
  border-radius: 1em;
  letter-spacing: 0.05rem;
  border: 0.15rem solid var(--clr-gray300);
  font-size: 0.8rem;
  padding-top: 2em;
  padding-bottom: 0.65em;
  outline: none;
  background: var(--clr-gray300);
}

.forgotPassword__inputContainer input:focus {
  border: 0.15rem solid var(--clr-dark);
  background: var(--clr-light);
}

.forgotPassword__inputContainer input::placeholder {
  color: transparent;
}

.forgotPassword__inputContainer input:focus::placeholder {
  color: var(--clr-gray400);
}

.forgotPassword__inputContainer input:focus ~ label {
  color: var(--clr-gray600);
}

.forgotPassword__inputContainer input:placeholder-shown ~ label {
  top: 0.6rem;
}

.forgotPassword__inputContainer input:focus ~ label {
  top: 0rem;
  left: 1em;
  /* font-size: 12px; */
  /* background: #fff; */
  font-size: 0.8rem;
  padding: 0.25em 0.5em;
  text-align: center;
  transition: all 0.5s;
}

.forgotPassword__inputContainer input:-webkit-autofill,
.forgotPassword__inputContainer input:-webkit-autofill:hover,
.forgotPassword__inputContainer input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.forgotPassword__inputContainer input:focus ~ .forgotPassword__inputClose {
  display: flex;
  pointer-events: all;
}

.forgotPassword__inputClose {
  display: none;
  right: 1rem;
  width: 1rem;
  cursor: pointer;
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}

.forgotPassword__forgotPassword {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  margin-top: -1.5rem;
}

.forgotPassword__alertSucces {
  background: var(--clr-success);
  color: var(--clr-success-dark);
  display: block;
  padding: 1em;
  font-size: 0.9rem;
  border-radius: 0.75em;
  margin-bottom: 1rem;
}

.forgotPassword__alert {
  background: var(--clr-error);
  color: var(--clr-error-dark);
  display: block;
  padding: 1em;
  font-size: 0.9rem;
  border-radius: 0.75em;
  margin-bottom: 1rem;
}

@media (min-width: 992px) {
  .forgotPassword {
    padding: 1em 0 5em 0;
  }
  .forgotPassword__container {
    flex: 1 1 60%;
    padding-left: 3rem;
    margin-left: 2rem;
    border-left: 0.1rem solid var(--clr-gray);
  }

  .forgotPassword__note {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,6CAA6C;EAC7C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;EAC3C;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".forgotPassword {\n  padding: 3em 0;\n}\n\n.forgotPassword__container {\n  display: flex;\n  flex-direction: column;\n  padding: 3em 0;\n  margin-top: 2rem;\n  gap: 1rem;\n  max-width: 45rem;\n  width: 100%;\n}\n\n.forgotPassword__title {\n  font-size: 2rem;\n  margin-bottom: 0.25rem;\n}\n\n.forgotPassword__title ~ span {\n  line-height: 1.8;\n}\n\n.forgotPassword__connect {\n  margin-top: 2rem;\n}\n\n.forgotPassword__connect h4 {\n  font-weight: bold;\n}\n\n.forgotPassword__connectOptions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.forgotPassword__connectBtn {\n  border: 0.15rem solid var(--clr-primary);\n  color: var(--clr-primary);\n  flex: 1 1 33%;\n  background: transparent;\n  justify-content: center;\n  border-radius: 0.75em;\n  font-weight: bold;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  max-width: unset;\n  padding: 1em 1.25em;\n}\n\n.forgotPassword__connectBtn img,\n.forgotPassword__connectBtn svg {\n  width: 1.25rem;\n  margin-left: 0.5rem;\n}\n\n.forgotPassword__connectBtn img {\n  margin-right: 0.5rem;\n}\n\n.forgotPassword__connectBtn.google {\n  border: 0.15rem solid var(--clr-black);\n  color: var(--clr-black);\n}\n.forgotPassword__connectBtn.facebook {\n  border: 0.15rem solid var(--clr-blue);\n  color: var(--clr-blue);\n}\n\n.forgotPassword__or {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  font-weight: bolder;\n  margin: 2rem auto;\n  color: var(--clr-gray500);\n  font-size: 0.9rem;\n  z-index: 1;\n}\n\n.forgotPassword__or::before,\n.forgotPassword__or::after {\n  content: \"\";\n  position: absolute;\n  height: 0.05rem;\n  width: 45%;\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--clr-gray500);\n}\n.forgotPassword__or::before {\n  left: 0;\n}\n.forgotPassword__or::after {\n  right: 0;\n}\n\n.forgotPassword__btn {\n  width: 100%;\n  font-size: 1rem;\n  font-weight: bold;\n  justify-content: center;\n  padding-block: 0.75em;\n  border-radius: 0.75em;\n  margin-top: 1.5rem;\n}\n\n.forgotPassword__btn svg {\n  width: 1.75rem;\n  margin-left: 0.5rem;\n}\n\n.forgotPassword__note {\n  display: flex;\n  align-items: center;\n  line-height: 1.5;\n  text-align: center;\n  margin-top: 1rem;\n  font-size: 0.8rem;\n  justify-content: center;\n}\n\n.forgotPassword__note svg {\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n\n/* input */\n\n.forgotPassword__input {\n  display: grid;\n  gap: 1rem;\n  /* margin-bottom: 3rem; */\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n}\n\n.forgotPassword__input.login {\n  display: flex;\n  flex-direction: column;\n}\n\n.forgotPassword__inputContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 20%;\n  width: 100%;\n  position: relative;\n}\n\n.forgotPassword__inputContainer.error input {\n  border: 2px solid var(--clr-error-dark);\n}\n\n.forgotPassword__inputContainer label {\n  position: absolute;\n  left: 1rem;\n  top: 0rem;\n  color: var(--clr-gray400);\n  font-size: 0.9rem;\n  font-weight: 400;\n  letter-spacing: 0.05rem;\n  margin: 0.5rem 0;\n  cursor: text;\n}\n\n.forgotPassword__inputContainer input::placeholder {\n  letter-spacing: 0.05rem;\n}\n\n.forgotPassword__inputContainer input {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-weight: 400;\n  padding: 1em 1.25em;\n  border-radius: 1em;\n  letter-spacing: 0.05rem;\n  border: 0.15rem solid var(--clr-gray300);\n  font-size: 0.8rem;\n  padding-top: 2em;\n  padding-bottom: 0.65em;\n  outline: none;\n  background: var(--clr-gray300);\n}\n\n.forgotPassword__inputContainer input:focus {\n  border: 0.15rem solid var(--clr-dark);\n  background: var(--clr-light);\n}\n\n.forgotPassword__inputContainer input::placeholder {\n  color: transparent;\n}\n\n.forgotPassword__inputContainer input:focus::placeholder {\n  color: var(--clr-gray400);\n}\n\n.forgotPassword__inputContainer input:focus ~ label {\n  color: var(--clr-gray600);\n}\n\n.forgotPassword__inputContainer input:placeholder-shown ~ label {\n  top: 0.6rem;\n}\n\n.forgotPassword__inputContainer input:focus ~ label {\n  top: 0rem;\n  left: 1em;\n  /* font-size: 12px; */\n  /* background: #fff; */\n  font-size: 0.8rem;\n  padding: 0.25em 0.5em;\n  text-align: center;\n  transition: all 0.5s;\n}\n\n.forgotPassword__inputContainer input:-webkit-autofill,\n.forgotPassword__inputContainer input:-webkit-autofill:hover,\n.forgotPassword__inputContainer input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.forgotPassword__inputContainer input:focus ~ .forgotPassword__inputClose {\n  display: flex;\n  pointer-events: all;\n}\n\n.forgotPassword__inputClose {\n  display: none;\n  right: 1rem;\n  width: 1rem;\n  cursor: pointer;\n  pointer-events: none;\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n}\n\n.forgotPassword__forgotPassword {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-top: -1.5rem;\n}\n\n.forgotPassword__alertSucces {\n  background: var(--clr-success);\n  color: var(--clr-success-dark);\n  display: block;\n  padding: 1em;\n  font-size: 0.9rem;\n  border-radius: 0.75em;\n  margin-bottom: 1rem;\n}\n\n.forgotPassword__alert {\n  background: var(--clr-error);\n  color: var(--clr-error-dark);\n  display: block;\n  padding: 1em;\n  font-size: 0.9rem;\n  border-radius: 0.75em;\n  margin-bottom: 1rem;\n}\n\n@media (min-width: 992px) {\n  .forgotPassword {\n    padding: 1em 0 5em 0;\n  }\n  .forgotPassword__container {\n    flex: 1 1 60%;\n    padding-left: 3rem;\n    margin-left: 2rem;\n    border-left: 0.1rem solid var(--clr-gray);\n  }\n\n  .forgotPassword__note {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
